export default {
  path: '/wecode/appinfo/:appId',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'appinfo',
  component: () => import('./index')
};
